import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient.js';
import { type JobScope } from 'api/queries/useLaundroworksCustomerSyncJobs';

interface TriggerResponse {
  success: boolean;
  message: string;
  jobId: string | number;
  businessId?: number;
}

export const addLaundroworksCustomerSyncJob = (
  businessId: number,
  scope: JobScope,
): AxiosPromise<TriggerResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/laundroworks/customer-sync/trigger`,
    data: { businessId, scope },
  });
};

export const addLaundryCatCustomerSyncJob = (
  businessId: number,
  scope: JobScope,
): AxiosPromise<TriggerResponse> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/laundrycat/customer-sync/trigger`,
    data: { businessId, scope },
  });
};
